import * as React from "react";
import { perPageList, sortByList, useSales } from "./useSales";
import { Drawer } from "app/components/drawer/drawer";
import { SalesTable } from "./components/salesTable";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from "@nextui-org/react";
import { CheckIcon, PlusIcon } from "@heroicons/react/24/solid";
import classNames from "classnames";
import { titleize } from "app/utils/string";
import { OpenSaleScreen } from "./components/openSaleScreen/openSaleScreen";
import { ClosedSaleScreen } from "./components/closedSaleScreen/closedSaleScreen";
import { SaleStatusTypes } from "app/redux/salesSlice";
import { includes } from "lodash";
import { Loading } from "app/components/loading/loading";
import { useBreakpoint } from "app/utils/useBreakpoint";
import { AsButton, Badge } from "app/subframe";
import { EmptyState } from "app/components/emptyState";
import { Icon } from "@subframe/core";
import {ChevronDown, CreditCard, DollarSign, Download, Package, Search, User} from "lucide-react";
import TransactionDetailsModal from "./components/transactionDetailsScreen/TransactionDetailsModal";
import QuickCheckoutModal from "app/schedules/newCalendar/modals/QuickCheckoutModal";
import {useEffect, useState} from "react";

export interface SalesProps {}

export const Sales: React.FC<SalesProps> = () => {
  const {
    shouldShowDrawer,
    setShouldShowDrawer,
    rowsPerPage,
    onSaleRowClick,
    sortBy,
    setSortBy,
    setRowsPerPage,
    saleIdParam,
    statusParam,
    handleClientSearch,
    onOpenNewCheckoutDrawer,
    onResetDrawerScreens,
    saleStatusCondition,
    setSaleStatusCondition,
    loading,
    totalCount,
    onCloseDrawer,
    selectCorrespondingScreen,
    sales,
    employeeIdsToFilter,
    setEmployeeIdsToFilter,
    employees,
    onCloseTransactionDetailsModal,
    searchTerm,
    setSearchTerm,
    filterStatus,
    setFilterStatus,
    exportSales,
    fetchSales,
  } = useSales();
  // The new-checkout drawer is disabled, so the phone "New checkout" button opens Quick Checkout instead
  const [showQuickCheckout, setShowQuickCheckout] = useState(false);

  const { isBelowSm, isAboveSm } = useBreakpoint("sm");
  //
  // const totalRevenue = transactions
  //     .filter(t => t.status === 'completed')
  //     .reduce((sum, t) => sum + t.totalAmount, 0);
  //
  // const totalServiceRevenue = transactions
  //     .filter(t => t.status === 'completed')
  //     .reduce((sum, t) => sum + t.serviceAmount, 0);
  //
  // const totalTips = transactions
  //     .filter(t => t.status === 'completed')
  //     .reduce((sum, t) => sum + t.tipAmount, 0);

  // Mock product revenue data - in a real app this would come from actual product sales
  const totalProductRevenue = 2450; // Example product revenue



  if (loading) {
    return (
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2">
        <Loading type="dark" />
      </div>
    );
  }

  const screenToShow =
    saleIdParam && statusParam === SaleStatusTypes.OPEN ? (
      <OpenSaleScreen
        handleClientSearch={handleClientSearch}
        saleStatusCondition={saleStatusCondition}
        onCloseDrawer={onCloseDrawer}
        setSaleStatusCondition={setSaleStatusCondition}
        selectCorrespondingScreen={selectCorrespondingScreen}
      />
    ) : saleIdParam &&
      includes([SaleStatusTypes.CLOSED, SaleStatusTypes.VOID], statusParam) ? (
      <ClosedSaleScreen setShouldShowDrawer={setShouldShowDrawer} />
    ) : !saleIdParam && !statusParam ? (
      <OpenSaleScreen
        handleClientSearch={handleClientSearch}
        saleStatusCondition={saleStatusCondition}
        onCloseDrawer={onCloseDrawer}
        setSaleStatusCondition={setSaleStatusCondition}
        selectCorrespondingScreen={selectCorrespondingScreen}
      />
    ) : null;


  return (
    <div
      className={classNames("flex flex-col p-4 gap-4 mobile:p-2", {
        "h-[85dvh]": isBelowSm && shouldShowDrawer,
      })}
    >
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold text-gray-900">Transactions</h1>
        {/*<button className="flex items-center space-x-2 px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-50">*/}
        {/*  <span>All Time</span>*/}
        {/*  <ChevronDown className="w-4 h-4" />*/}
        {/*</button>*/}
      </div>

      {/*<div className="grid grid-cols-1 md:grid-cols-4 gap-6">*/}
      {/*  <div className="bg-white rounded-lg border border-gray-200 p-6">*/}
      {/*    <div className="flex items-center justify-between">*/}
      {/*      <div>*/}
      {/*        <p className="text-sm font-medium text-gray-600">Total Revenue</p>*/}
      {/*        <p className="text-2xl font-bold text-gray-900 mt-1">${4500}</p>*/}
      {/*        <p className="text-sm text-green-600 mt-1">+12% from last week</p>*/}
      {/*      </div>*/}
      {/*      <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center">*/}
      {/*        <DollarSign className="w-6 h-6 text-white" />*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}

      {/*  <div className="bg-white rounded-lg border border-gray-200 p-6">*/}
      {/*    <div className="flex items-center justify-between">*/}
      {/*      <div>*/}
      {/*        <p className="text-sm font-medium text-gray-600">Total Tips</p>*/}
      {/*        <p className="text-2xl font-bold text-gray-900 mt-1">${200}</p>*/}
      {/*        <p className="text-sm text-purple-600 mt-1">Staff gratuities</p>*/}
      {/*      </div>*/}
      {/*      <div className="w-12 h-12 bg-purple-500 rounded-lg flex items-center justify-center">*/}
      {/*        <User className="w-6 h-6 text-white" />*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}

      {/*  <div className="bg-white rounded-lg border border-gray-200 p-6">*/}
      {/*    <div className="flex items-center justify-between">*/}
      {/*      <div>*/}
      {/*        <p className="text-sm font-medium text-gray-600">Service Revenue</p>*/}
      {/*        <p className="text-2xl font-bold text-gray-900 mt-1">${32443}</p>*/}
      {/*        <p className="text-sm text-blue-600 mt-1">Treatment payments</p>*/}
      {/*      </div>*/}
      {/*      <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center">*/}
      {/*        <CreditCard className="w-6 h-6 text-white" />*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}

      {/*  <div className="bg-white rounded-lg border border-gray-200 p-6">*/}
      {/*    <div className="flex items-center justify-between">*/}
      {/*      <div>*/}
      {/*        <p className="text-sm font-medium text-gray-600">Product Revenue</p>*/}
      {/*        <p className="text-2xl font-bold text-gray-900 mt-1">${totalProductRevenue.toLocaleString()}</p>*/}
      {/*        <p className="text-sm text-green-600 mt-1">Retail & product sales</p>*/}
      {/*      </div>*/}
      {/*      <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center">*/}
      {/*        <Package className="w-6 h-6 text-white" />*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}


      {isBelowSm && (
        <span className="text-[20px] font-[500] leading-[30px] text-neutral-700">
          Sales
        </span>
      )}
      {/*<Drawer*/}
      {/*  isOpen={shouldShowDrawer}*/}
      {/*  setIsOpen={setShouldShowDrawer}*/}
      {/*  backdrop={false}*/}
      {/*  hideCloseBtn={true}*/}
      {/*  onClose={onResetDrawerScreens}*/}
      {/*>*/}
      {/*  {screenToShow}*/}
      {/*</Drawer>*/}


      {saleIdParam && (
          <TransactionDetailsModal
              onClose={onCloseTransactionDetailsModal}
          />
      )}
      {showQuickCheckout && (
          <QuickCheckoutModal
              onClose={() => {
                setShowQuickCheckout(false);
                fetchSales();
              }}
              onComplete={() => {}}
          />
      )}
      <div className="flex items-center justify-between ">
        {isAboveSm ? (
          <div className="flex gap-2 items-center">
            {/*<AsButton*/}
            {/*  variant="neutral-secondary"*/}
            {/*  size="md"*/}
            {/*  onClick={() => onOpenNewCheckoutDrawer()}*/}
            {/*>*/}
            {/*  <PlusIcon className="w-4 h-4 stroke-black" />*/}
            {/*  <p className="font-semibold ">New Checkout</p>*/}
            {/*</AsButton>*/}
          </div>
        ) : (
          <span className="grow shrink-0 basis-0 text-[14px] font-[400] leading-[20px] text-neutral-700">
            {totalCount} sales
          </span>
        )}
        <div className="flex gap-4">
          <div className="flex gap-4">
            <Dropdown>
              <DropdownTrigger>
                <AsButton
                  variant="ghost"
                  trailingIcon="FeatherChevronDown"
                  text="Sort"
                  size="sm"
                  className="text-neutral-900 hover:bg-millet-500"
                  loader={false}
                  disabled={false}
                />
              </DropdownTrigger>
              <DropdownMenu aria-label="Static Actions">
                {sortByList.map((sb) => (
                  <DropdownItem
                    key={sb}
                    className="data-[hover=true]:!bg-millet-500 data-[focus=true]:!bg-millet-500"
                    onClick={() => setSortBy(sb)}
                    endContent={
                      <CheckIcon
                        className={classNames("w-3 h-3 stroke-black", {
                          hidden: sb !== sortBy,
                        })}
                      />
                    }
                  >
                    {titleize(sb)}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
            <Dropdown>
              <DropdownTrigger>
                <AsButton
                  variant="ghost"
                  leadingIcon={null}
                  trailingIcon="FeatherChevronDown"
                  className="text-neutral-900 hover:bg-millet-500"
                  text={`${rowsPerPage} per page`}
                  size="sm"
                  loader={false}
                />
              </DropdownTrigger>
              <DropdownMenu aria-label="Static Actions">
                {perPageList.map((perPage) => (
                  <DropdownItem
                    className="data-[hover=true]:!bg-millet-500 data-[focus=true]:!bg-millet-500"
                    key={perPage}
                    onClick={() => setRowsPerPage(perPage)}
                  >
                    {perPage} per page
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>
          {isAboveSm && (
            <div className="flex items-center gap-2 relative">
              <p className="text-sm text-default-500">Filter by</p>
              <Dropdown>
                <DropdownTrigger>
                  <AsButton
                    variant="ghost"
                    leadingIcon={null}
                    trailingIcon="FeatherChevronDown"
                    className="text-neutral-900 hover:bg-millet-500"
                    text={"Employee"}
                    size="sm"
                    loader={false}
                  />
                </DropdownTrigger>
                <DropdownMenu selectionMode="multiple" closeOnSelect={false}>
                  {/* employeeIdsToFilter,
                 setEmployeeIdsToFilter, */}
                  {employees.map((employee) => {
                    const isSelected = employeeIdsToFilter.includes(
                      employee.id
                    );
                    return (
                      <DropdownItem
                        key={employee.id}
                        className="data-[hover=true]:!bg-millet-500 data-[focus=true]:!bg-millet-500"
                        onClick={() => {
                          // Check if the employee ID already exists in the filter
                          if (isSelected) {
                            // If it exists, remove it
                            setEmployeeIdsToFilter(
                              employeeIdsToFilter.filter(
                                (id) => id !== employee.id
                              )
                            );
                          } else {
                            // If it doesn't exist, add it
                            setEmployeeIdsToFilter([
                              ...employeeIdsToFilter,
                              employee.id,
                            ]);
                          }
                        }}
                      >
                        <div className="flex gap-1 items-center">
                          <Icon
                            name="FeatherCheck"
                            className={classNames({
                              invisible: !isSelected,
                            })}
                          />
                          {employee.name}
                        </div>
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </Dropdown>
              {employeeIdsToFilter.length > 0 && (
                <Badge
                  variant="success"
                  className="absolute h-4 w-4 -top-1 -right-1 rounded-full z-10"
                >
                  {employeeIdsToFilter.length}
                </Badge>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="bg-white rounded-lg border border-gray-200">
        <div className="sm:p-6 p-2 border-b border-gray-200">
          <div className="flex items-center flex-col gap-2 sm:flex-row w-full justify-between">
            <div className={'flex justify-start flex-col w-full'}>
              <h2 className="text-xl font-semibold text-gray-900">Transaction History</h2>
              <p className="text-gray-500 text-sm mt-1">Complete payment and transaction records</p>
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-end space-x-4 w-full">
              <div className="relative flex justify-end">
                <Search className="w-4 h-4 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                    type="text"
                    placeholder="Search transactions..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="pl-9 pr-4 py-3 text-sm border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full sm:w-80"
                />
              </div>

              <div className={' flex gap-2 py-2'}>

              <select
                  value={filterStatus}
                  onChange={(e) => setFilterStatus(e.target.value)}
                  className="text-sm border-2 border-blue-500 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
              >
                <option value="all">All Status</option>
                <option value="completed">Completed</option>
                <option value="pending">Pending</option>
                <option value="refunded">Refunded</option>
              </select>

              <button
                onClick={exportSales}
                className="flex items-center space-x-2 bg-purple-600 text-white px-6 py-3 text-sm rounded-xl hover:bg-purple-700"
              >
                <Download className="w-4 h-4" />
                <span>Export</span>
              </button>
              </div>


            </div>
          </div>
        </div>
        {sales.length === 0 ? (
          <div className="w-full py-16 flex justify-center items-center flex-col gap-6">
            <EmptyState />
            <AsButton
              text={"No Sale has been recorded so far"}
              onClick={() =>{}}
            />
          </div>
        ) : (
          <SalesTable rowsPerPage={rowsPerPage} onSaleRowClick={onSaleRowClick} />
        )}
      </div>
      {/* Hidden while a modal is open so it doesn't float over it */}
      {isBelowSm && !saleIdParam && !showQuickCheckout && (
        <AsButton
          variant="brand"
          leadingIcon="FeatherPlus"
          trailingIcon={null}
          text="New checkout"
          size="md"
          loader={false}
          shadow
          onClick={() => setShowQuickCheckout(true)}
          className="fixed bottom-24 self-center z-50"
        />
      )}
    </div>
  );
};
